<section *ngIf="workflow.workflowId"
		 class="max-w-4xl mx-auto py-2 px-4 rounded-lg my-3">
	<h3 class="text-xs sm:text-sm font-semibold mb-4 flex gap-2.5 justify-between">
		<span>Production Updates</span>
		<p [ngClass]="workflow.status"
		   *ngIf="(workflow.status==='COMPLETED' && product.orderStatus === 'IN_TRANSIT')">Dispatched</p>
		<p [ngClass]="workflow.status"
		   *ngIf="workflow.status==='INITIATED'">In-Progress</p>
		<p [ngClass]="workflow.status"
		   *ngIf="workflow.status==='COMPLETED' && product.orderStatus !== 'IN_TRANSIT'">Ready-To-Dispatch</p>
	</h3>
	<div class="w-full flex flex-row justify-start items-start space-x-4 fb-step-overflow fb-disable-scrollbar">
		<div class="w-full flex"
			 [ngClass]="workflow.steps && workflow.steps.length > 2? 'justify-between': 'justify-center'">
			<div *ngFor="let step of workflow.steps"
				 class="f-stepper relative flex flex-row justify-start items-stretch"
				 [ngClass]="step.stepStatus === 'COMPLETED'? 'f-step-done': (step.stepStatus === 'IN_PROGRESS'? 'f-step-in-progress':'')">
				<div class="text-center flex flex-col items-center  mx-[30px]">
					<div class="h-8 w-8 rounded-full flex items-center justify-center text-anuprerna-250 text-xs text-center" [ngClass]="step.stepStatus === 'PENDING' || step.stepStatus === 'HALTED'? 'bg-anuprerna-200': (step.stepStatus === 'COMPLETED'? 'bg-anuprerna-10': 'bg-anuprerna-20')" >
						<span *ngIf="step.stepStatus !== 'IN_PROGRESS'" class="material-symbols-outlined">{{step.stepStatus === 'PENDING' || step.stepStatus === 'HALTED'? 'hourglass_top': (step.stepStatus === 'COMPLETED'? 'check': '')}}</span>
						<span *ngIf="step.stepStatus === 'IN_PROGRESS'" class="text-[9px]">{{step.stepProgress ? step.stepProgress.toFixed(1) : '0'}}%</span>
					</div>
					<p class="text-xs mt-2">{{step.stepName}}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="w-full flex justify-center items-center my-2">
		<button class="w-max text-[#8E7862] border-b-2 pb-1 flex items-center justify-center gap-2 text-xs border-[#6c5b48] "
				type="submit"
				(click)="onViewProcessUpdates('')">
			<span>{{!showProcess? 'See' : 'Hide'}}</span> all updates
			<span class="material-symbols-outlined animate-bounce">{{!showProcess ? 'stat_minus_2': 'stat_2'}}</span>
		</button>
	</div>

</section>
